<div class="flex items-stretch w-full max-w-sm bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden"
     role="alert">

  <!-- Barra de acento lateral -->
  <div class="w-1 flex-shrink-0"
       [ngClass]="{
         'bg-emerald-500': statusClass === 'success',
         'bg-red-500':     statusClass === 'error',
         'bg-amber-500':   statusClass === 'warning',
         'bg-indigo-500':  statusClass === 'info'
       }">
  </div>

  <!-- Contenido -->
  <div class="flex items-start gap-3 px-4 py-3.5 flex-1">

    <!-- Icono -->
    <div class="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-lg mt-0.5"
         [ngClass]="{
           'bg-emerald-100 text-emerald-600': statusClass === 'success',
           'bg-red-100 text-red-600':         statusClass === 'error',
           'bg-amber-100 text-amber-600':     statusClass === 'warning',
           'bg-indigo-100 text-indigo-600':   statusClass === 'info'
         }">

      <!-- Success -->
      <svg *ngIf="statusClass === 'success'" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
      </svg>
      <!-- Error -->
      <svg *ngIf="statusClass === 'error'" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
      </svg>
      <!-- Warning -->
      <svg *ngIf="statusClass === 'warning'" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
      </svg>
      <!-- Info -->
      <svg *ngIf="statusClass === 'info'" class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
      </svg>

    </div>

    <!-- Texto -->
    <div class="flex-1 min-w-0">
      <p class="text-sm font-semibold text-slate-800 leading-tight">{{ title }}</p>
      <p class="text-xs text-slate-500 mt-1 leading-snug break-words">{{ message }}</p>
      <p class="text-xs text-slate-400 mt-1.5">{{ hour }}</p>
    </div>

    <!-- Botón cerrar -->
    <button
      type="button"
      (click)="dismiss()"
      class="flex-shrink-0 flex items-center justify-center w-6 h-6 rounded-md text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors duration-150 mt-0.5"
      aria-label="Cerrar"
    >
      <svg class="w-3 h-3" fill="none" viewBox="0 0 14 14" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
      </svg>
    </button>

  </div>
</div>
